export enum OffersScreenNames {
  MAIN = 'offers',
  OFFERS = 'offers_list',
  OFFER = 'offer',
}
